import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { gsap } from 'gsap';

import config from '@config';
import { getOnAirClass } from '@helpers';

const Card = ({ program, channel, type, openDetailPanel }) => {
  if (program.now_next && program.now_next == 'now') {
    return (
      <li className="fv-card-slider__card">
        <a
          href={program.player_links.web.live_stream}
          rel="noopener"
          target="_blank"
        >
          <div
            className="fv-card-slider__card__bg"
            style={
              program.image_url
                ? {
                    backgroundImage: `url(${program.image_url}?w=${config.programCardImageWidth})`,
                  }
                : {}
            }
          />
          {channel && (
            <img
              className="fv-card-slider__card__logo"
              src={`${channel.images.default}?w=${config.channelImageWidth}`}
              alt={channel.title}
            />
          )}
          <div className="fv-card-slider__card__infos">
            {program.secondary_title && <span>{program.secondary_title}</span>}
            <h6>{program.main_title}</h6>
          </div>
          <div className="fv-card-slider__card__on-air" />
        </a>
      </li>
    );
  } else if (program) {
    return (
      <li
        className="fv-card-slider__card"
        onClick={() => {
          openDetailPanel(type, program.uuid, program.program_id);
        }}
      >
        <div
          className="fv-card-slider__card__bg"
          style={
            program.image_url
              ? {
                  backgroundImage: `url(${program.image_url}?w=${config.programCardImageWidth})`,
                }
              : {}
          }
        />
        {channel && (
          <img
            className="fv-card-slider__card__logo"
            src={`${channel.images.default}?w=${config.channelImageWidth}`}
            alt={channel.title}
          />
        )}
        <div className="fv-card-slider__card__infos">
          {program.secondary_title && <span>{program.secondary_title}</span>}
          <h6>{program.main_title}</h6>
        </div>
        {getOnAirClass(moment.utc(), program.start_time, program.duration) ===
          'is-onair' && <div className="fv-card-slider__card__on-air" />}
      </li>
    );
  }
  return null;
};

class ProgramHightlight extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolling: false,
    };

    this.onMouseMove = this.onMouseMove.bind(this);
  }

  toggleScrolling(isEnable) {
    if (isEnable) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp.bind(this));
    } else {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  onMouseMove(event) {
    const { clientX, scrollLeft, scrollTop, clientY } = this.state;
    this._scroller.scrollLeft = scrollLeft - clientX + event.clientX;
    this._scroller.scrollTop = scrollTop - clientY + event.clientY;
  }

  onMouseUp(e) {
    this.setState({
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0,
      clientX: 0,
      clientY: 0,
    });
  }

  onMouseDown(event) {
    const { scrollLeft, scrollTop } = this._scroller;
    this.setState({
      isScrolling: true,
      scrollLeft,
      scrollTop,
      clientX: event.clientX,
      clientY: event.clientY,
    });
  }

  attachScroller(scroller) {
    this._scroller = ReactDOM.findDOMNode(scroller);
  }

  handleNavClick(direction) {
    const elWidth = this._scroller.children[3].clientWidth;
    const distance = direction > 0 ? elWidth : elWidth * -1;
    gsap.to(this._scroller, 0.5, {
      scrollLeft: this._scroller.scrollLeft + distance,
    });
  }

  render() {
    const missingProgArray = ['a', 'a', 'a', 'a', 'a'];

    return (
      <div className="fv-card-slider">
        <h3>{this.props.title}</h3>
        <div className="fv-card-slider__nav fv-carousel">
          <div
            className="fv-card-slider__nav__cta fv-card-slider__nav__cta--left"
            onClick={this.handleNavClick.bind(this, -1)}
          >
            <span className="fv-directional-cta fv-directional-cta--left" />
          </div>
          <div
            className="fv-card-slider__nav__cta fv-card-slider__nav__cta--right"
            onClick={this.handleNavClick.bind(this, 1)}
          >
            <span className="fv-directional-cta fv-directional-cta--right" />
          </div>
        </div>
        <ul
          className="fv-card-slider__container"
          ref={this.attachScroller.bind(this)}
          onMouseDown={this.onMouseDown.bind(this)}
        >
          <li className="fv-card-slider__card fv-card-slider__card--hidden visible-mobile" />
          {this.props.programs &&
            this.props.programs.map(p => (
              <Card
                program={p}
                channel={this.props.channels.find(
                  c => c.service_id == p.service_id,
                )}
                type={this.props.type}
                openDetailPanel={this.props.openDetailPanel}
                key={`hightlight-${p.uuid}-${this.props.title}`}
              />
            ))}
          {missingProgArray.map((el, index) => (
            <li
              key={index}
              className="fv-card-slider__card fv-card-slider__card--hidden"
            >
              <div className="fv-card-slider__card__bg" />
            </li>
          ))}
          <li className="fv-card-slider__card fv-card-slider__card--hidden" />
        </ul>
      </div>
    );
  }
}

export default ProgramHightlight;
